import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import MarketPlaceBar from "../../components/marketplace/MarketPlaceBar";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import StoreCard from "../../components/marketplace/StoreCard";

const MarketPlaceHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('المتاجر');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'المتاجر'};

    const [selectedUnit, setSelectedUnit] = useState(null);
    const [stores, setStores] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getNearbyStores = async () => {
        setIsLoading(true);
      try {
        const response = await apiClient.get(`/stores/nearby?longitude=${selectedUnit?.long}&latitude=${selectedUnit?.lat}`);
        if(response?.data) {
          setStores(response?.data);
          setIsLoading(false);
        } else {
            setIsLoading(false);
        }
      } catch(err) {setIsLoading(false);}
    }

    useEffect(()=>{
        if(selectedUnit) {
            getNearbyStores();
        }
    },[selectedUnit]);

    const handleClickStore = (id) => {
        navigate(`/ar/marketplace/store/${id}`);
    }

  return (
    <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>
                    <MarketPlaceBar storesCount={stores?.length} setSelectedUnit={setSelectedUnit} selectedUnit={selectedUnit} />
                    {/* no selected store view */}
                    {!selectedUnit && <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/shop.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">من فضلك اختر وحدة أولاً لعرض المتاجر القريبة منك</div>
                        </div>}
                    {/* no stores view */}
                    {selectedUnit && stores !== null && Array.isArray(stores) && stores?.length < 1 && 
                        <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/shop.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لا توجد أيمتاجر متاحة في هذه المحافظة حتي الان</div>
                        </div>
                    }
                    {/* stores view */}
                    {selectedUnit && stores !== null && Array.isArray(stores) && stores?.length > 0 && <div className="pt-[25px] flex flex-wrap gap-[15px]">
                        {stores?.map((store,index)=>{
                            return (<StoreCard key={`store-${index}`} store={store} handleClickStore={handleClickStore} />)
                        })}
                    </div>}
                    
                </MainContent>
            </PageMain>

            {isLoading && <Loading showLoading={true} />}
    </div>
  );
};

export default MarketPlaceHomePage;
